var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"coming-soon"},[_c('Banner',{on:{"applied":_vm.newApplication}}),_c('SuccessModal',{attrs:{"id":_vm.id,"position":_vm.position}}),_c('how-it-works'),_c('social-marketing'),_c('fosters-support')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }